import { render } from "./PhotoFrame.vue?vue&type=template&id=551cc5da&scoped=true"
import script from "./PhotoFrame.vue?vue&type=script&lang=js"
export * from "./PhotoFrame.vue?vue&type=script&lang=js"

import "./photo-frame.scss?vue&type=style&index=0&id=551cc5da&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551cc5da"]])

export default __exports__